import { CDN_URL } from '../../config.js';
import { fetchCache } from '../../utils/fetchCache.js';

const EXCEPTIONS_PATH = '/data/scenarios/exceptions.json';
const FREE_OUTFIT_IDS = new Set(['0', '1']);

let cachedExceptionKeys = null;
let exceptionLoadPromise = null;

const normalizeId = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).trim();
};

const toTupleKey = (scenarioId, characterId, outfitId) =>
    `${normalizeId(scenarioId)}:${normalizeId(characterId)}:${normalizeId(outfitId)}`;

const normalizeExceptionKeys = (payload) => {
    const exceptions = Array.isArray(payload?.exceptions) ? payload.exceptions : [];
    const keys = new Set();

    for (const entry of exceptions) {
        const scenarioId = normalizeId(entry?.scenarioId);
        const characterId = normalizeId(entry?.characterId);
        const outfitId = normalizeId(entry?.outfitId);
        if (!scenarioId || !characterId || !outfitId) continue;
        keys.add(toTupleKey(scenarioId, characterId, outfitId));
    }

    return keys;
};

export async function loadOutfitExceptionKeys() {
    if (cachedExceptionKeys) return cachedExceptionKeys;
    if (exceptionLoadPromise) return exceptionLoadPromise;

    exceptionLoadPromise = (async () => {
        try {
            const payload = await fetchCache.fetchJSON(`${CDN_URL}${EXCEPTIONS_PATH}`);
            cachedExceptionKeys = normalizeExceptionKeys(payload);
            return cachedExceptionKeys;
        } catch (error) {
            console.warn('[outfit-exceptions] Failed to load exceptions:', error);
            cachedExceptionKeys = new Set();
            return cachedExceptionKeys;
        } finally {
            exceptionLoadPromise = null;
        }
    })();

    return exceptionLoadPromise;
}

export function isOutfitAllowedForContext({
    hasPaidMembership,
    scenarioId,
    characterId,
    outfitId,
    exceptionKeys
}) {
    if (hasPaidMembership) return true;

    const normalizedOutfitId = normalizeId(outfitId);
    if (FREE_OUTFIT_IDS.has(normalizedOutfitId)) return true;

    if (!exceptionKeys || !(exceptionKeys instanceof Set) || exceptionKeys.size === 0) return false;
    return exceptionKeys.has(toTupleKey(scenarioId, characterId, normalizedOutfitId));
}
